import { render } from "./Movies.vue?vue&type=template&id=a03f2882&scoped=true"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"

import "./Movies.scss?vue&type=style&index=0&id=a03f2882&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03f2882"]])

export default __exports__